export default __webpack_public_path__ + "static/bb1-da2ff60d43eb07abc6691324b7f77b47.jpeg";